// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maultipopup {
  max-height: 200px;
  overflow: auto;
  margin-top: 3%;
}`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytic-builder/publish-analytics/publish-analytics.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EACA,cAAA;AACJ","sourcesContent":[".maultipopup {\r\n    max-height: 200px;\r\n    overflow: auto;\r\n    margin-top: 3%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
